const context = require.context('./', false, /^\.\/(?!index).*\.js$/);
const configs = context.keys().reduce((acc, key) => {
    // './telus.js' -> 'telus'
    const channelName = key.replace('./', '').replace('.js', '');
    acc[channelName] = context(key).default;
    return acc;
}, {});

export default configs;
